export default {
      id: "oc-dashboard-top5-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-top5",
      toString: function () {
        return this.url;
      }
    }